function MetricCard({
  title,
  value,
  color,
  bg,
  desc,
  callback
}) {
  return (
    <div
      className={`rounded-xl px-4 py-3 ${bg}    ${`shadow hover:scale-[1.02] cursor-pointer`}` } onClick={() =>callback?callback(title):''}>
      <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
        {title}
      </div>
      <div
        className={`mt-1 text-2xl font-black ${color}`}
      >
        {value}
      </div>
      <div className="text-sm text-gray-500 mt-1">
        {desc}
      </div>
    </div>
  );
}

export default MetricCard;